export const GET_CLIENTS_LISTING = "GET_CLIENTS_LISTING";
export const GET_CLIENTS_DETAIL = "GET_CLIENTS_DETAIL";
